import { render } from "./NotificationListComponent.vue?vue&type=template&id=80f5ae7e&scoped=true"
import script from "./NotificationListComponent.vue?vue&type=script&lang=js"
export * from "./NotificationListComponent.vue?vue&type=script&lang=js"

import "./NotificationListComponent.vue?vue&type=style&index=0&id=80f5ae7e&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f5ae7e"]])

export default __exports__